export default __webpack_public_path__ + "4bb0a7ed2c7444e3c2093050aa71216a.png";